<select [formControl]="control" class="form-select">
  @if (displayPlaceholder && placeholder != null) {
  <option [ngValue]="ignoreValue">
    {{ placeholder }}
  </option>
  } @for (option of options; track option) {
  <option [ngValue]="option.value">
    {{ option.label }}
  </option>
  }
</select>
